import { render, staticRenderFns } from "./AttendanceStudentList.vue?vue&type=template&id=45389d6a"
import script from "../../controllers/attendance_student/attendance-student-list.js?vue&type=script&lang=js&external"
export * from "../../controllers/attendance_student/attendance-student-list.js?vue&type=script&lang=js&external"
import style0 from "./AttendanceStudentList.vue?vue&type=style&index=0&id=45389d6a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports